module.exports = __webpack_public_path__ + "img/Group 890one2.004b3dae.svg";